import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=5813feee&scoped=true&"
import script from "./FormContent.vue?vue&type=script&lang=js&"
export * from "./FormContent.vue?vue&type=script&lang=js&"
import style0 from "./FormContent.vue?vue&type=style&index=0&id=5813feee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813feee",
  null
  
)

export default component.exports